// TODO: Clean up and Consolidate after DataContext is REMOVED
export const DATA_VIEW_STAGED = 'DATA_VIEW_STAGED';

export const DATA_SOURCES_UPDATE = 'DATA_SOURCES_UPDATE';
export const DATA_SOURCES_ALIAS_UPDATE = 'DATA_SOURCES_ALIAS_UPDATE';
export const DATA_SOURCES_FILTER_UPDATE = 'DATA_SOURCES_FILTER_UPDATE';

// TODO: Refer to comment in reducer
export const DATA_ACTIVE_PROJECT = 'DATA_ACTIVE_PROJECT';
export const DATA_PORTFOLIO_FILTER_VALUES = 'DATA_PORTFOLIO_FILTER_VALUES';
export const DATA_SELECTED_PROJECTS_VALUE = 'DATA_SELECTED_PROJECTS_VALUE';

// TODO: Add State for Bulk Requests
// State of batch requests
export const DATA_SOURCES_CANCEL_TOKEN = 'DATA_SOURCES_CANCEL_TOKEN';

export const DELETE_ME_INCREMENT_STEP = 'DELETE_ME_INCREMENT_STEP';

export const DATA_DATA_DATE = 'DATA_DATA_DATE';